import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/node_modules/@codegouvfr/react-dsfr/Accordion.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/ui/app/_components/link/DsfrLink.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BaseProcessusSection"] */ "/app/ui/app/(public)/_components/shared/BaseProcessusSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EtablissementsConnectesSection"] */ "/app/ui/app/(public)/_components/shared/EtablissementsConnectesSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui/app/(public)/_components/shared/footer-cta-section.module.scss");
;
import(/* webpackMode: "eager" */ "/app/ui/app/(public)/_components/shared/faq-section.module.scss");
;
import(/* webpackMode: "eager" */ "/app/ui/app/(public)/_components/shared/base-sponsors-section.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TemoignagesSection"] */ "/app/ui/app/(public)/_components/shared/TemoignagesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/app/ui/app/(public)/accueil-cfa/_components/FeaturesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/ui/app/(public)/accueil-cfa/_components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PourquoiCollaborerSection"] */ "/app/ui/app/(public)/accueil-cfa/_components/PourquoiCollaborerSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/ui/app/(public)/landing-page.module.scss");
